const TABLE_TITLE_CONFIG = {
    cost: {
        configKey: 'cost_details_table_title',
        translationKey: 'invoice.cost_details',
        fallback: 'Cost Detail',
    },
    gl: {
        configKey: 'gl_details_table_title',
        translationKey: 'invoice.gl_details',
        fallback: 'GL Detail',
    },
};

/**
 * Resolve a client-configurable line-item table title.
 * Custom client values are literal, while missing or blank values keep the translated defaults.
 */
export const getLineItemTableTitle = (data, tableType) => {
    const titleConfig = TABLE_TITLE_CONFIG[tableType];
    if (!titleConfig) return '';

    const customTitle = data?.config?.frontend_invoice?.[titleConfig.configKey];
    if (typeof customTitle === 'string' && customTitle.trim()) {
        return customTitle.trim();
    }

    const translatedTitle = data?.t?.read?.(titleConfig.translationKey);
    return typeof translatedTitle === 'string' || typeof translatedTitle === 'number'
        ? translatedTitle
        : titleConfig.fallback;
};
